<div class="main">
    <div class="section">
      <div class="header">
        {{'ADD_HOLIDAYS.title' | translate}}
        <i class="material-icons" (click)="closeDialog();">clear</i>
      </div>
      <div class="container">
        <div class="content">
          <div class="inputSection">
            <div class="label">
              {{'ADD_HOLIDAYS.mark_holiday' | translate}}<sup style="color: #E54131; font-weight: 900;">*</sup>
            </div>
            <mat-form-field class="form-field">
              <mat-chip-list #chipList
                (click)="picker.open()">
                <mat-chip
                  *ngFor="let value of model"
                  [selectable]="false"
                  [removable]="true"
                  (removed)="remove(value)">
                  {{ value | date }}
                  <mat-icon matChipRemove *ngIf="true">cancel</mat-icon>
                </mat-chip>
                <input [value]="resetModel" matInput [matDatepicker]="picker"
                        (dateChange)="dateChanged($event)"
                        [matChipInputFor]="chipList" hidden />
              </mat-chip-list>
              <mat-datepicker-toggle matPrefix [for]="picker"></mat-datepicker-toggle>
              <mat-datepicker #picker [startAt]="init" [dateClass]="dateClass"></mat-datepicker>
            </mat-form-field>
            <br/>
            <mat-hint>({{'ADD_HOLIDAYS.hint' | translate}})</mat-hint>
          </div>
          <div class="inputSection">
            <div class="label">
               {{'ADD_HOLIDAYS.leave_type' | translate}}<sup style="color: #E54131; font-weight: 900;">*</sup>
            </div>
            <div class="inputSelect">
              <mat-select [(ngModel)]="selectedLeaveType" >
                <mat-option *ngFor="let type of leave_types" [value]="type" (click)="selectLeaveType(type)">
                    {{type.name}}
                </mat-option>
              </mat-select>
            </div>
          </div>
          <div class="inputSection">
            <div class="label">
               {{'ADD_HOLIDAYS.comment' | translate}}<sup style="color: #E54131; font-weight: 900;">*</sup>
            </div>
            <input class="input" [(ngModel)]="description">
          </div>
        </div>
        <div class="submitButton" style="float: right;">
          <div class="button" (click)="submit();">
            {{'ADD_HOLIDAYS.submitLab' | translate}}
          </div>
        </div>
      </div>
    </div>
  </div>
  